export default __webpack_public_path__ + "static/media/093-curved-arrow-2.fd2c8099.png";